"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _lodash = _interopRequireDefault(require("lodash.get"));

var _baseclient = _interopRequireDefault(require("./baseclient"));

var LOUDSPEAKER_RESOURCE_ID = 'loudspeaker';
var CUSTOMIZR_BASE_URL = 'https://customizr.at.cimpress.io';
/**
 * Provides access to the Customizr service for reading and writing "acknowledgement timestamps"
 * associated with each loudspeaker channel.
 */

var CustomizrClient =
/*#__PURE__*/
function (_BaseClient) {
  (0, _inherits2.default)(CustomizrClient, _BaseClient);

  function CustomizrClient(configuration) {
    var _this;

    (0, _classCallCheck2.default)(this, CustomizrClient);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CustomizrClient).call(this, configuration));
    _this.loudspeakerSettings = {};
    return _this;
  }
  /**
   * Retrieve the timestamp this user last acknowledged announcements from a specific channel.
   */


  (0, _createClass2.default)(CustomizrClient, [{
    key: "getLastAcknowledgementTimestamp",
    value: function () {
      var _getLastAcknowledgementTimestamp = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee() {
        var response;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return fetch("".concat(CUSTOMIZR_BASE_URL, "/v1/resources/").concat(LOUDSPEAKER_RESOURCE_ID, "/settings"), {
                  method: 'GET',
                  headers: this.headers
                });

              case 3:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 6;
                  break;
                }

                throw new Error('Loudspeaker: Failed to retrieve last acknowledgement timestamp.');

              case 6:
                _context.next = 8;
                return response.json();

              case 8:
                this.loudspeakerSettings = _context.sent;
                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);
                console.warn(_context.t0.message);
                this.loudspeakerSettings = {};

              case 15:
                return _context.abrupt("return", (0, _lodash.default)(this.loudspeakerSettings, "".concat(this.channelId, ".lastAcknowledgementTimestamp")));

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 11]]);
      }));

      return function getLastAcknowledgementTimestamp() {
        return _getLastAcknowledgementTimestamp.apply(this, arguments);
      };
    }()
    /**
     * Set the new "acknowledgement timestamp" for a specific channel.
     */

  }, {
    key: "acknowledgeAnnouncements",
    value: function () {
      var _acknowledgeAnnouncements = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2() {
        var body, response;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                body = Object.assign({}, this.loudspeakerSettings, (0, _defineProperty2.default)({}, this.channelId, {
                  lastAcknowledgementTimestamp: new Date().toISOString()
                }));
                _context2.prev = 1;
                _context2.next = 4;
                return fetch("".concat(CUSTOMIZR_BASE_URL, "/v1/resources/").concat(LOUDSPEAKER_RESOURCE_ID, "/settings"), {
                  method: 'PUT',
                  headers: this.headers,
                  body: JSON.stringify(body)
                });

              case 4:
                response = _context2.sent;

                if (response.ok) {
                  _context2.next = 7;
                  break;
                }

                throw new Error('Loudspeaker: Failed to acknowledge announcments.');

              case 7:
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](1);
                console.warn(_context2.t0.message);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 9]]);
      }));

      return function acknowledgeAnnouncements() {
        return _acknowledgeAnnouncements.apply(this, arguments);
      };
    }()
  }]);
  return CustomizrClient;
}(_baseclient.default);

exports.default = CustomizrClient;